import { getAuthApiModule } from './modules/auth';
import { getAffiliatesApiModule } from './modules/affiliates';
import { getOffersApiModule } from './modules/offers';
import { getPaymentsApiModule } from './modules/payments';
import { getPlayersApiModule } from './modules/players';
import { getReportsApiModule } from './modules/reports';
import { getToolsApiModule } from './modules/tools';
import { getSettingsApiModule } from './modules/settings';
import { getProfileApiModule } from './modules/profile';
import { getMiscApiModule } from './modules/misc';
import { getLiveApiModule } from './modules/live';
import { getBookmarkApiModule } from './modules/bookmark';
import { getTeamApiModule } from './modules/team';
import { getMediaBuyingApiModule } from './modules/mediaBuying';
import { getFileApiModule } from './modules/file';
import { getCommentApiModule } from './modules/comment';
import { getPromocodeApiModule } from './modules/promocode';
import { getDomainManagementApiModule } from './modules/domainManagement';
import { getMarketingMaterialsApiModule } from './modules/marketingMaterials';
import { getDashboardsApiModule } from './modules/dashboards';
import { getCrmApiModule } from './modules/crm';
import { getTrafficSourcesApiModule } from './modules/traffic-sources';
import type { AxiosInstance } from 'axios';

export function createRequest(affiliatesApi: AxiosInstance, miscApi: AxiosInstance) {
  return {
    affiliatesApi,
    miscApi,

    ...getAuthApiModule(affiliatesApi),
    ...getAffiliatesApiModule(affiliatesApi),
    ...getOffersApiModule(affiliatesApi),
    ...getPaymentsApiModule(affiliatesApi),
    ...getPlayersApiModule(affiliatesApi),
    ...getReportsApiModule(affiliatesApi),
    ...getToolsApiModule(affiliatesApi),
    ...getSettingsApiModule(affiliatesApi),
    ...getProfileApiModule(affiliatesApi),
    ...getMiscApiModule(affiliatesApi, miscApi),
    ...getLiveApiModule(affiliatesApi),
    ...getBookmarkApiModule(affiliatesApi),
    ...getTeamApiModule(affiliatesApi),
    ...getPromocodeApiModule(affiliatesApi),
    ...getMediaBuyingApiModule(affiliatesApi),
    ...getFileApiModule(affiliatesApi),
    ...getCommentApiModule(affiliatesApi),
    ...getDomainManagementApiModule(affiliatesApi),
    ...getMarketingMaterialsApiModule(affiliatesApi),
    ...getDashboardsApiModule(affiliatesApi),
    ...getCrmApiModule(affiliatesApi),
    ...getTrafficSourcesApiModule(affiliatesApi),
  };
}